import ChatbotPopup from '../../../Chatbot/ChatbotPopup/ChatbotPopup'
import ConversationsNavFilters from '../ConversationsFilters/ConversationsFilters'

import styles from './conversations-nav-head.module.scss'

function ConversationsNavHead() {
    return (
        <div className={styles.conversationsNavHead}>
            <ChatbotPopup />
            <ConversationsNavFilters />
        </div>
    )
}

export default ConversationsNavHead
